import script from "./projectCalendarSideList.vue?vue&type=script&setup=true&lang=js"
export * from "./projectCalendarSideList.vue?vue&type=script&setup=true&lang=js"

import "./projectCalendarSideList.vue?vue&type=style&index=0&id=132a16f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132a16f4"]])

export default __exports__